/* My changes start here 1 */

console.log('Hello World')

document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".blog-articles");

  function checkForVisibility() {
    items.forEach(function (item) {
      const itemRect = item.getBoundingClientRect();
      if (itemRect.top < window.innerHeight) {
        item.classList.add("animate");
      }
    });
  }

  checkForVisibility();

  window.addEventListener("scroll", checkForVisibility);
});

/* My changes end here 1 */